let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jgSrF")).then(() => parcelRequire('jkwZN'));